import React from 'react';
import { CardInvalide } from '../Cards';

const PageEcourrierKo = ({ location }) => (
    <CardInvalide Lien="/">
        <p>Un problème est survenu lors de l&apos;inscription au service courrier électronique.</p>
        {location.state && location.state.raison ? (
            <p>{location.state.raison}</p>
        ) : (
            <p>Ce lien n&apos;est plus valide.</p>
        )}
        <p>Merci de vérifier que vous n&apos;avez pas un email plus récent ou recommencer la procédure.</p>
    </CardInvalide>
);

export default PageEcourrierKo;



// WEBPACK FOOTER //
// ./src/components/Adherent/Ecourrier/PageEcourrierKo.js